var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-expand-batches-content", class: `is-${_vm.variant}` },
    [
      !_vm.progress?.message && !_vm.hasBatches
        ? _c("p", { staticClass: "wkb-expand-batches-empty" }, [
            _vm._v(
              " Neighbor classification batches appear when expansion uses intent or known/novel filters. "
            ),
          ])
        : _vm.progress?.message && !_vm.hasBatches
        ? _c("p", { staticClass: "wkb-expand-batches-status" }, [
            _vm._v(" " + _vm._s(_vm.progress.message) + " "),
          ])
        : [
            _vm.neighborGoalSummary
              ? _c(
                  "p",
                  {
                    staticClass: "wkb-expand-batches-goal",
                    attrs: { role: "status" },
                  },
                  [_vm._v(" " + _vm._s(_vm.neighborGoalSummary) + " ")]
                )
              : _vm._e(),
            _vm.progress?.message
              ? _c(
                  "p",
                  {
                    staticClass: "wkb-expand-batches-status",
                    attrs: { role: "status" },
                  },
                  [_vm._v(" " + _vm._s(_vm.progress.message) + " ")]
                )
              : _vm._e(),
            _vm.showProgressBar
              ? _c(
                  "div",
                  {
                    staticClass: "wkb-expand-batches-progress",
                    attrs: {
                      role: "progressbar",
                      "aria-valuenow": _vm.progressValue,
                      "aria-valuemin": 0,
                      "aria-valuemax": _vm.progressMax,
                      "aria-label": _vm.progressAriaLabel,
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "wkb-expand-batches-progress-bar",
                      style: { width: `${_vm.progressPercent}%` },
                    }),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "wkb-expand-batches-guidance" }, [
              _c("p", { staticClass: "wkb-expand-batches-intro" }, [
                _vm._v(_vm._s(_vm.batchDescription)),
              ]),
              _c(
                "p",
                {
                  staticClass:
                    "wkb-expand-batches-intro wkb-expand-batches-termination",
                },
                [_vm._v(" " + _vm._s(_vm.batchTerminationNote) + " ")]
              ),
            ]),
            _c(
              "ul",
              {
                staticClass: "wkb-expand-batches-list",
                attrs: { "aria-label": "Neighbor classification batches" },
              },
              _vm._l(_vm.progress.batches, function (batch) {
                return _c(
                  "li",
                  {
                    key: batch.index,
                    staticClass: "wkb-expand-batches-item",
                    class: `is-${batch.status}`,
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "wkb-expand-batches-marker",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        batch.status === "running"
                          ? _c("span", {
                              staticClass: "wkb-expand-batches-spinner",
                            })
                          : batch.status === "complete"
                          ? _c("span", [_vm._v("✓")])
                          : batch.status === "skipped"
                          ? _c("span", [_vm._v("–")])
                          : _c("span", [_vm._v("•")]),
                      ]
                    ),
                    _c("div", { staticClass: "wkb-expand-batches-copy" }, [
                      _c("span", { staticClass: "wkb-expand-batches-label" }, [
                        _vm._v(" " + _vm._s(_vm.batchRangeLabel(batch)) + " "),
                      ]),
                      batch.detail
                        ? _c(
                            "span",
                            { staticClass: "wkb-expand-batches-detail" },
                            [_vm._v(" " + _vm._s(batch.detail) + " ")]
                          )
                        : _vm._e(),
                    ]),
                    _c("span", { staticClass: "wkb-expand-batches-state" }, [
                      _vm._v(_vm._s(_vm.batchStatusLabel(batch.status))),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }